module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = 386
// module chunks = 5